import { IValidationJSONSchemaMessages } from '@estee/elc-form';
import { computed, observable } from 'mobx';
import { translationKeysFieldMappings } from '../../../constants/AddressFieldsStaticDefinitions';
import { ITranslationSchema } from '../../../interfaces/ITranslationFields';
import { FormField } from '../../../views/GenericForm/types';
import { FIELD_TYPE } from '../../../constants/Constants';
import { ValidationSchema } from './GenericFormStore';

interface IInputFieldDataConfig {
  field: FormField;
  translations: ITranslationSchema;
}

export class DataField {
  @observable config: IInputFieldDataConfig;

  constructor(config: IInputFieldDataConfig) {
    this.config = config;
  }

  @computed get validationMessages(): IValidationJSONSchemaMessages {
    const { field, translations } = this.config;
    // translation key names by field property name
    const keyNames = translationKeysFieldMappings[field.id as FIELD_TYPE];
    const maxLengthMessage = keyNames?.maxLength && translations[keyNames.maxLength] as string;
    const minLengthMessage = keyNames?.minLength && translations[keyNames.minLength] as string || '';
    const patternMessage = keyNames && translations[keyNames.invalid] as string || '';
    const requiredMessage = keyNames && translations[keyNames.required] as string || '';

    return {
      maxLengthMessage,
      minLengthMessage,
      patternMessage,
      requiredMessage,
    };
  }

  @computed get emailValidation(): ValidationSchema {
    const { field, translations } = this.config;
    // translation key names by field property name
    const keyNames = translationKeysFieldMappings[field.id as FIELD_TYPE];
    const patternMessage = keyNames && translations[keyNames.invalid] as string || '';
    const requiredMessage = keyNames && translations[keyNames.required] as string || '';

    return {
      email: patternMessage,
      required: requiredMessage,
    };
  }

  @computed get label(): string {
    const { field, translations } = this.config;
    const keyNames = translationKeysFieldMappings[field.id as FIELD_TYPE];
    let translatedLabel;

    if (field.labelKey) {
      translatedLabel = translations[field.labelKey];
    }
    if (!translatedLabel) {
      if (keyNames) {
        translatedLabel = translations[keyNames.label];
      } else {
        translatedLabel = `${field.id}`;
      }
    }

    return translatedLabel as string;
  }

  @computed get field(): FormField {
    return this.config.field;
  }
}
